import { deleteRatesEnterpriseCityRequest } from "../../data/ratesEnterpriseCityApi";

export async function deleteTarifaEnterpriseCityUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa ciudad a ciudad es obligatorio.");
  }

  return await deleteRatesEnterpriseCityRequest(id);
}
